import * as actionTypes from '../actions/actionsTypes';

import { updateObject } from '../../utils/common';

const initialState = {
  favouriteCustomers: [],
};

const setFavouriteCustomers = (state, action) => {
  return updateObject(state, {
    favouriteCustomers: action.data,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETFAVOURITECUSTOMERS:
      return setFavouriteCustomers(state, action);
    default:
      return state;
  }
};

export default reducer;
